// extracted by mini-css-extract-plugin
export default {"childAgeSelectors":"childAgeSelectors__3GgCk","label":"label__3YnWm","option":"option__2ETko","optionLabel":"optionLabel__24PzA"};